function goldCoin(size: number = 32): string {
  return `<svg width="${size}" height="${size}" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <!-- Shadow -->
    <ellipse cx="17" cy="28" rx="10" ry="2" fill="rgba(0,0,0,0.1)"/>
    <!-- Coin edge -->
    <circle cx="16" cy="15" r="12" fill="#DAA520" stroke="#B8860B" stroke-width="1.5"/>
    <!-- Coin face -->
    <circle cx="16" cy="15" r="10" fill="#FFD700" stroke="#DAA520" stroke-width="1"/>
    <!-- Inner ring -->
    <circle cx="16" cy="15" r="7" fill="none" stroke="#DAA520" stroke-width="0.8"/>
    <!-- G emboss -->
    <text x="16" y="19" text-anchor="middle" font-size="10" font-weight="bold" font-family="serif" fill="#B8860B" opacity="0.7">G</text>
    <!-- Highlight -->
    <path d="M10,10 Q14,6 20,10" fill="none" stroke="rgba(255,255,255,0.4)" stroke-width="1.5" stroke-linecap="round"/>
  </svg>`;
}

export const CURRENCY_ICONS: Record<string, (size?: number) => string> = {
  gold: goldCoin,
};
